module.exports = __webpack_public_path__ + "img/close.da3424ec.png";